// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".share-menu-module__list--331m1{display:inline-flex}.share-menu-module__item--3Elhm{width:30px;height:30px;margin-right:10px;position:relative}.share-menu-module__itemLink--2Yi-J{display:block}.share-menu-module__itemImage--1lKN-,.share-menu-module__itemLink--2Yi-J{width:100%;height:100%}.share-menu-module__text--JNQsz{margin-bottom:10px;color:#fff}", ""]);
// Exports
exports.locals = {
	"list": "share-menu-module__list--331m1",
	"item": "share-menu-module__item--3Elhm",
	"itemLink": "share-menu-module__itemLink--2Yi-J",
	"itemImage": "share-menu-module__itemImage--1lKN-",
	"text": "share-menu-module__text--JNQsz"
};
module.exports = exports;
